export const companyProfile = {
  slug: 'serenita',
  name: 'Serenita',
  legalName: 'Serenita',
  tagline: 'Servizi linguistici e operativi su misura',
  description: 'Supporto linguistico, amministrativo e operativo per team europei che devono livellare tempi di risposta e qualità.',
  website: 'https://www.serenitacg.com',
  hero: {
    eyebrow: 'Serenita Enterprise Desk',
    headline: 'Hub linguistico e operativo full service',
    subheadline: 'Interpreti, responsabili admin et taskforce eventi coordinati in meno di 24 ore.'
  },
  contact: {
    email: 'contact@serenitacg.com',
    phone: '+(242) 05 695 56 37 / +(242) 06 592 59 92'
  },
  address: {
    line1: 'Tours Jumelles Villarecci, 1er Étage',
    line2: '76 Avenue Amilcar Cabral (face Hotel Radisson)',
    city: 'Brazzaville',
    country: 'Congo-Brazzaville'
  },
  locales: {
    default: 'fr',
    available: ['it', 'fr', 'en', 'pt-BR']
  },
  languages: ['it', 'fr', 'en', 'pt-BR'],
  timezone: 'Africa/Brazzaville',
  brand: {
    primaryColor: '#2A3756',
    secondaryColor: '#CF9A6B',
    accentColor: '#F2E8DA',
    logoUrl: 'https://cdn.serenitaeg.com/assets/logo.svg'
  },
  socials: {
    facebook: 'https://www.facebook.com/serenitacg',
    instagram: 'https://www.instagram.com/serenitacg/',
    linkedin: 'https://www.linkedin.com/company/serenitacg',
    tiktok: null
  },
  seo: {
    defaultTitle: 'Serenita | Servizi linguistici e operativi',
    defaultDescription: 'Coordinamento linguistico, amministrativo e eventi premium pour aziende europee con SLA 24 ore.'
  },
  signature: '-- Team Serenita'
}

export default companyProfile
